import { gql } from "@apollo/client";

export const RETRIEVE_MENU_BY_ID = gql`
    query gqlRetrieveMenuById($nID: Int!) {
        data: gqlRetrieveMenuById(nID: $nID) {
            nID
            sNameKey
            sDescriptionKey
            nPrice
            languages
            categories {
                nID
                sNameKey
                sProducts
                nOrder
                languages
            }
        }
    }
`;

export const RETRIEVE_PUBLIC_MENUS = gql`
    query gqlRetrievePublicMenus($nIDRestaurant: Int!) {
        data: gqlRetrievePublicMenus(nIDRestaurant: $nIDRestaurant) {
            nID
            sNameKey
            sDescriptionKey
            nPrice
            languages
            categories {
                nID
                sNameKey
                nOrder
                products {
                    sImages
                    nPrice
                    languages
                }
                languages
            }
        }
    }
`;

export const RETRIEVE_MENUS = gql`
    query gqlRetrieveMenus($nIDRestaurant: Int!) {
        data: gqlRetrieveMenus(nIDRestaurant: $nIDRestaurant) {
            nID
            sNameKey
            sDescriptionKey
            nPrice
            languages
            categories {
                nID
                sNameKey
                sProducts
                languages
            }
        }
    }
`;